import { IPagination } from '@models';
import { IPaymentTermsResponseData, IPaymentTermsTableData } from '.';
import { IListingData } from '@models/listing';
import { isEmpty } from '@utils/validationUtils';

export function mapToListingPaymentTermsData(data: {
  paging: IPagination;
  items: IPaymentTermsResponseData[];
}): IListingData {
  if (isEmpty(data)) {
    return {
      pagedItems: {},
      pageSize: 10,
      pageNumber: 1,
      totalCount: 0,
    };
  }

  const list: Record<string, IPaymentTermsTableData> = {};

  data?.items?.forEach((obj: IPaymentTermsResponseData, index: number) => {
    const parentBillType = obj.parentBill_ParentBillCategory;
    const policyType = obj.businessPartnerPolicy_Type;
    let reference: string = obj.businessPartnerPolicy_PolicyNumber;

    if (policyType === 'CERTIFICATE') {
      reference += ' ' + obj.businessPartnerPolicy_CertificateNumber;
    }

    if (['ENDORSEMENT', 'CANCELLATION'].includes(parentBillType)) {
      reference += ' ' + obj.linkedAmendment_AmendmentNumber;
    }

    list[index] = {
      reference: reference,
      netPremium: obj.payableBill_NetPremium,
      grossPremium: obj.payableBill_GrossPremium,
      totalPremium: obj.payableBill_TotalPremium,
      amountReceived: obj.businessPartnerPolicy_TotalAmountReceived,
      commission: obj.payableBill_TotalCommission,
      taxOnCommission: obj.payableBill_TaxOnCommission,
      amountPaid: obj.payableBill_AmountPaid,
      totalBalance: Number(
        (
          Number(obj.payableBill_TotalPremium) -
          obj.businessPartnerPolicy_TotalAmountReceived -
          (Number(obj.payableBill_TotalCommission) -
            Number(obj.payableBill_TaxOnCommission) -
            obj.payableBill_AmountPaid)
        ).toFixed(3)
      ),
      Currency: obj.businessPartnerPolicy_PolicyCurrency?.Symbol,
    };
  });

  return {
    pagedItems: list,
    pageSize: data?.paging?.pageSize,
    pageNumber: data?.paging?.pageNumber,
    totalCount: data?.paging?.totalCount,
  };
}
